const LOCAL_API_BASE_URL = 'http://localhost:8000/';

const PROD_API_BASE_URL = 'https://kum-backend-staging.herokuapp.com/';

export default {
  API_BASE_URL:
    process.env.NODE_ENV === 'production'
      ? PROD_API_BASE_URL
      : LOCAL_API_BASE_URL,
};
